/* Riviera Couture — endless scroll for collection & search grids (with Load more fallback) */
(function () {
  var loading = false;
  var observer = null;
  var current = null;

  function gridIn(root) {
    var el = root.getElementById ? root.getElementById('product-grid') : root.querySelector('#product-grid');
    if (!el) return null;
    return el.tagName === 'UL' ? el : el.querySelector('ul.product-grid');
  }

  function load(sentinel) {
    if (loading || !sentinel || !sentinel.dataset.next) return;
    loading = true;
    sentinel.classList.add('is-loading');
    var url = new URL(sentinel.dataset.next, window.location.href);
    url.searchParams.set('section_id', sentinel.dataset.section);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = gridIn(document);
        var src = gridIn(doc);
        if (!grid || !src) throw new Error('grid not found');
        var seen = {};
        grid.querySelectorAll('a[href*="/products/"]').forEach(function (a) { seen[a.getAttribute('href').split('?')[0]] = 1; });
        Array.prototype.slice.call(src.children).forEach(function (li) {
          var a = li.querySelector('a[href*="/products/"]');
          if (a && seen[a.getAttribute('href').split('?')[0]]) return; // no duplicates
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          li.querySelectorAll('.scroll-trigger').forEach(function (n) { n.classList.remove('scroll-trigger'); });
          grid.appendChild(document.importNode(li, true));
        });
        var next = doc.querySelector('[data-rc-infinite]');
        sentinel.dataset.next = next && next.dataset.next ? next.dataset.next : '';
        loading = false;
        sentinel.classList.remove('is-loading');
        if (!sentinel.dataset.next) { sentinel.remove(); if (observer) observer.disconnect(); current = null; return; }
        if (observer) { observer.unobserve(sentinel); observer.observe(sentinel); }
        var r = sentinel.getBoundingClientRect();
        if (r.top < window.innerHeight + 800) load(sentinel); // keep filling the screen
      })
      .catch(function () {
        loading = false;
        sentinel.classList.remove('is-loading');
        sentinel.classList.add('is-error'); // shows the Load more button
      });
  }

  function init() {
    var sentinel = document.querySelector('[data-rc-infinite]');
    if (sentinel === current) return; // already watching this one
    if (observer) { observer.disconnect(); observer = null; }
    current = sentinel;
    if (!sentinel) return;
    document.documentElement.classList.add('rc-infinite-on');
    var btn = sentinel.querySelector('[data-rc-more]');
    if (btn) btn.addEventListener('click', function () { sentinel.classList.remove('is-error'); load(sentinel); });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) load(e.target); });
      }, { rootMargin: '0px 0px 800px 0px' });
      observer.observe(sentinel);
    } else {
      sentinel.classList.add('is-error');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Re-arm after filters / sorting re-render the grid
  var container = document.getElementById('ProductGridContainer');
  if (container) new MutationObserver(function () { if (!loading) init(); }).observe(container, { childList: true });
})();
